module.exports = __webpack_public_path__ + "static/img/cp-left.b5b95a81.png";